export const TIMELINE_COLORS = {
  CONSTRUCTION: '#3b82f6',
  RENOVATION: '#10b981',
  CONSTRUCTION_PHASE: '#f59e0b',
  DWELLING_ADDED: '#ec4899',
  PRESENT: '#8b5cf6',
  TIMELINE_LINE: '#e5e7eb',
}

export const AGE_THRESHOLDS = {
  NEW: 10,
  CONTEMPORARY: 30,
  MATURE: 50,
}

export const RENOVATION_THRESHOLDS = {
  RECENT: 5,
  GOOD: 15,
  CONSIDER_UPDATES: 30,
}

export const DWELLING_YEAR_THRESHOLD = 1999
